import { FormsList } from "../../../components/forms-overview/FormsList";
import { FormsListEmpty } from "../../../components/forms-overview/FormsListEmpty";
import { FormsListComponentState } from "../../../components/forms-overview/FormsListComponentState";
import { FormsListError } from "../../../components/forms-overview/FormsListError";
import { FilterWrapper } from "../../../components/form-filter/FilterWrapper";
import { FormFilter } from "../../../../core/models/FormFilter";
import { Form } from "../../../../core/entities/form";
import { ContentBox } from "../../../components/structure/ContentBox";
import { ScreenHeader } from "../../../components/structure/ScreenHeader";
import { PageQuery } from "../../../../core/page-query/models/pageQuery";
import { parseFormFilterToPageQuery } from "../../../../core/page-query/parsers/parseFormFilterToPageQuery";
import { parsePageQueryToFormFilter } from "../../../../core/page-query/parsers/parsePageQueryToFormFilter";
import { InfinityListComponent } from "../../../components/infinity-list.component";
import { FormsListLoading } from "../../../components/forms-overview/FormsListLoading";
import { SortBy } from "../../../../core/page-query/models/sortBy";

export interface FormOverview_VM {
    listComponentState?: FormsListComponentState;
    pq: PageQuery;
    forms: Form[];
    onFilterReset: () => void;

    onQueryChange(filterFormModel: PageQuery): void;
    onSortChange(sortBy: SortBy): void;
    onFormRowClick(form: Form): void;

    onScrollEndReached(): void;

    isLoading: boolean;
    totalRecords: number;
}

export function FormsOverviewComponent({
    listComponentState,
    forms,
    onFilterReset,
    onFormRowClick,
    onQueryChange,
    pq,
    isLoading,
    onScrollEndReached,
    totalRecords,
    onSortChange
}: FormOverview_VM) {
    function handleQueryChange(filterFormModel: FormFilter) {
        const newPageQuery = parseFormFilterToPageQuery(
            filterFormModel,
            pq.sortBy
        );
        onQueryChange(newPageQuery);
    }

    const getFormsComponent = (state: FormsListComponentState): JSX.Element => {
        switch (state) {
            case FormsListComponentState.Empty:
                return <FormsListEmpty />;
            case FormsListComponentState.Content:
                return (
                    <InfinityListComponent
                        isLoading={isLoading}
                        onLoadMore={onScrollEndReached}
                    >
                        <FormsList
                            list={forms}
                            handleFormRow={onFormRowClick}
                            handleSortChanged={onSortChange}
                            sorting={pq.sortBy}
                        />
                    </InfinityListComponent>
                );
            case FormsListComponentState.Error:
                return <FormsListError />;
            case FormsListComponentState.Loading:
                return <FormsListLoading />;
        }
    };
    return (
        <>
            <ScreenHeader>Søg attester</ScreenHeader>
            <ContentBox className={"animate-fade-in"}>
                <FilterWrapper
                    handleFilterForm={handleQueryChange}
                    onFilterReset={onFilterReset}
                    filterForm={parsePageQueryToFormFilter(pq)}
                />
            </ContentBox>

            {listComponentState === FormsListComponentState.Content && (
                <div className={"mb-24 px-4 text-xn"}>
                    <b>{totalRecords}</b> resultater
                </div>
            )}

            {listComponentState !== undefined && (
                <>
                    <ContentBox
                        key={listComponentState}
                        className={"flex animate-fade-in"}
                    >
                        {getFormsComponent(listComponentState)}
                    </ContentBox>
                </>
            )}
        </>
    );
}
